import { asyncRoutes, constantRoutes } from '@/router'
import { getMenus } from '@/api/role'
import { TimePicker } from 'element-ui'
import { deepClone } from '@/utils'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
// export function filterAsyncRoutes(routes, roles) {
//   const res = [];

//   routes.forEach(route => {
//     const tmp = { ...route };
//     if (hasPermission(roles, tmp)) {
//       if (tmp.children) {
//         tmp.children = filterAsyncRoutes(tmp.children, roles);
//       }
//       res.push(tmp);
//     }
//   });

//   return res;
// }

/**
 * 依照傳入路由判斷有權限檢視的路由
 * @param routes 原始路由 物件為傳址 注意會被刪除child
 * @param syncRoutes 動態路由
 */
export function filterAsyncRoutes(routes, syncRoutes) {
  const res = []
  // 遍歷路由表 與傳進來的路由比對
  syncRoutes.forEach(route => {
    const tmp = { ...route }
    // 比對名稱是否符合
    if (!routes) {
      return
    }
    const hasRouter = routes.some(r => r.name == tmp.name)
    if (hasRouter) {
      // 比對有資料 取出該筆錄由(前端路由表主檔)
      const routeFind = routes.filter(f => {
        return f.name == tmp.name
      })[0]

      // 顯示參數交換
      routeFind.hidden = routeFind.meta && routeFind.meta.forceHidden ? true : tmp.hidden
      if (tmp.alwaysShow) {
        // alwaysShow 父層選單是否顯示
        routeFind.alwaysShow = tmp.alwaysShow
      }

      if (tmp.children && tmp.children.length > 0) {
        routeFind.children = filterAsyncRoutes(routeFind.children, tmp.children)
      }
      res.push(routeFind)
    }
  })

  return res
}

/**
 * 不分權限 顯示出所有路由
 * @param routes 原始路由
 */
export function showAllFilterAsyncRoutes(routes) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.children) {
      tmp.children = showAllFilterAsyncRoutes(tmp.children)
    }
    res.push(tmp)
  })

  return res
}

const state = {
  routes: [],
  addRoutes: [],
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise((resolve, reject) => {
      let accessedRoutes

      //使用api 取得後端權限
      // getMenus()
      //   .then(response => {
      //     const { data } = response
      //     const routes = data
      //     let cloneRoute = deepClone(asyncRoutes);
      //     // 依照api傳回權限分配路由
      //     accessedRoutes = filterAsyncRoutes(cloneRoute, routes)
      //     // 顯示全部路由
      //     // accessedRoutes = showAllFilterAsyncRoutes(asyncRoutes);
      //     commit('SET_ROUTES', accessedRoutes)
      //     resolve(accessedRoutes)
      //   })
      //   .catch(error => {
      //     reject(error)
      //   })

      //測試區直接取得全部錄由直接取得全部錄由  正是區使用api 取得後端權限
      // if (process.env.NODE_ENV != 'production') {
      if (false) {
        accessedRoutes = asyncRoutes || []
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes)
      } else {
        // 可改為api呼叫 動態決定路由
        getMenus()
          .then(response => {
            const { data } = response
            const routes = data
            let cloneRoute = deepClone(asyncRoutes)
            // 依照api傳回權限分配路由
            accessedRoutes = filterAsyncRoutes(cloneRoute, routes)

            // 顯示全部路由
            // accessedRoutes = showAllFilterAsyncRoutes(asyncRoutes);
            commit('SET_ROUTES', accessedRoutes)
            resolve(accessedRoutes)
          })
          .catch(error => {
            console.log(error)
            // reject(error)
          })
      }
    })
  },
}

// const actions = {
//   generateRoutes({ commit }, roles) {
//     let accessedRoutes

//     return new Promise(resolve => {
//       // 可改為api呼叫 動態決定路由
//       getMenus()
//         .then(response => {
//           const { data } = response
//           const routes = data
//           let cloneRoute = deepClone(asyncRoutes);
//           // 依照api傳回權限分配路由
//           accessedRoutes = filterAsyncRoutes(cloneRoute, routes)
//           // 顯示全部路由
//           // accessedRoutes = showAllFilterAsyncRoutes(asyncRoutes);
//           debugger;
//           commit('SET_ROUTES', accessedRoutes)
//           resolve(accessedRoutes)
//         })
//         .catch(error => {
//           reject(error)
//         })
//     })
//   }
// }

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
